export default {
  slots: {
    dot: 'size-2 hover:bg-primary duration-300 0 bg-white/60 mix-blend-normal',
    dots: 'bottom-3 gap-1.5',
  },
  variants: {
    active: {
      true: {
        dot: 'data-[state=active]:bg-white data-[state=active]:size-2.5 data-[state=active]:shadow-sm',
      },
    },
    orientation: {
      horizontal: {
        prev: 'sm:start-4',
        next: 'sm:end-4',
      },
    },
  },
}